import { render, staticRenderFns } from "./AllocatePaymentModal.vue?vue&type=template&id=d027d682&scoped=true"
import script from "./AllocatePaymentModal.vue?vue&type=script&lang=js"
export * from "./AllocatePaymentModal.vue?vue&type=script&lang=js"
import style0 from "./AllocatePaymentModal.vue?vue&type=style&index=0&id=d027d682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027d682",
  null
  
)

export default component.exports